import { render } from "./StockTransferGrid.vue?vue&type=template&id=0722767a"
import script from "./StockTransferGrid.vue?vue&type=script&lang=js"
export * from "./StockTransferGrid.vue?vue&type=script&lang=js"

import "./StockTransferGrid.vue?vue&type=style&index=0&id=0722767a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__